package com.bulut.mecitogullari.core.storage

import kotlinx.serialization.KSerializer
import kotlinx.serialization.serializer

/**
 * Key-value storage abstraction for the app.
 *
 * Supports primitives (String, Boolean) and arbitrary @Serializable objects.
 */
interface AppStorage {

    fun putString(key: String, value: String)
    fun getString(key: String, defaultValue: String? = null): String?

    fun putBoolean(key: String, value: Boolean)
    fun getBoolean(key: String, defaultValue: Boolean = false): Boolean

    fun <T> putObject(key: String, value: T, serializer: KSerializer<T>)
    fun <T> getObject(key: String, serializer: KSerializer<T>): T?

    fun remove(key: String)
    fun contains(key: String): Boolean
    fun clear()
}

inline fun <reified T> AppStorage.putObject(key: String, value: T) =
    putObject(key, value, serializer())

inline fun <reified T> AppStorage.getObject(key: String): T? =
    getObject(key, serializer())
